import { render } from "./UserNavigationDropdown.vue?vue&type=template&id=357e8af9"
import script from "./UserNavigationDropdown.vue?vue&type=script&lang=js"
export * from "./UserNavigationDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__